// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7be5a484","100":"fa5985cc","196":"742213fe","228":"1a3dedac","536":"924d145f","555":"8d3bbdc1","572":"0f8eb7cf","732":"d1699415","812":"cd414671","828":"aef61718","932":"5cbbe0dd","936":"6570f4f2","968":"cf8b3bd8"}[chunkId] + ".chunk.js";
};